import React, { useEffect, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import Slide from "@mui/material/Slide";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { SavedCardsModal } from "./SavedCardsModal";

function SlideTransition(props) {
  return <Slide {...props} direction="up" />;
}

export const FavoriteBar = () => {
  return <div>Favorite</div>;
};

export const FavoritePopUp = ({ open, setOpen, styles = {} }) => {
  const { data } = useSelector((state) => state.categories);

  const [openFavoriteModal, setOpenFavoriteModal] = useState(false);
  const [primaryFavorite, setPrimaryFavorite] = useState({
    name: "",
    id: "",
    is_primary: false,
  });
  const [categories, setCategories] = useState([]);

  const handleClose = () => {
    if (!openFavoriteModal) setOpen(false);
  };

  useEffect(() => {
    setCategories(data);
    const primary = data.filter((p) => p.is_primary);
    setPrimaryFavorite(primary?.[0]);
  }, [data]);

  return (
    <>
      <Snackbar
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        TransitionComponent={SlideTransition}
        autoHideDuration={10000}
        sx={{
          background: "white",
          position: "absolute !important",
          zIndex: 1000,
          borderRadius: "5px",
          boxShadow: "1px 1px 10px rgba(0,0,0, 0.3)",
          "& .MuiBox-root": {
            borderRadius: "5px",
            background: "transparent",
          },
          ...styles,
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: 1.5,
            borderRadius: 3,
          }}
        >
          <Typography sx={{ color: "text.main", fontSize: "15px" }}>
            Added to {primaryFavorite?.name}
          </Typography>
          <Typography
            variant="body4"
            color={"primary"}
            fontWeight={500}
            sx={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={() => {
              setOpenFavoriteModal(true);
            }}
          >
            {categories.length <= 1 ? "Change List" : "View List"}
          </Typography>
        </Box>
      </Snackbar>

      {openFavoriteModal && (
        <SavedCardsModal
          openFavoriteModal={openFavoriteModal}
          setOpenFavoriteModal={setOpenFavoriteModal}
          primaryFavorite={primaryFavorite}
          setCategories={setCategories}
          categories={categories}
        />
      )}
    </>
  );
};
